import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900">韩国漫画网</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费韩漫与漫画大全的聚合地，提供海量在线漫画资源，专注于推荐好看的韩国漫画，是您的一站式娱乐门户。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              <a href="#quick-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">分类浏览</Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱漫画</Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">奇幻漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              <a href="#popular-tags" className="cursor-pointer">热门标签</a>
            </h4>
            <div className="flex flex-wrap gap-2">
              {['恋爱', '奇幻', '悬疑', '校园', '古风', '重生', '甜宠', '热血'].map((tag) => (
                <Link
                  key={tag}
                  to={`/category/all`}
                  className="px-3 py-1 text-xs rounded-full bg-background-200 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              <a href="#contact" className="cursor-pointer">联系我们</a>
            </h4>
            <div className="space-y-2 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-sm"></i>
                </span>
                contact@koreanmanhwa.cn
              </p>
              <p className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-sm"></i>
                </span>
                安全阅读 · 绿色无广告
              </p>
            </div>
            <div className="flex gap-3 mt-4">
              <a href="#weibo" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#wechat" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#bilibili" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer" aria-label="哔哩哔哩" rel="nofollow">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {currentYear} 韩国漫画网. 本站内容仅供学习交流，版权归原作者所有。
          </p>
          <div className="flex gap-4">
            <a href="#privacy" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#terms" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            <a href="#dmca" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}